import React, { useEffect, useState } from "react";
import { arrayMove } from "react-sortable-hoc";
import SortQuestions from "./SortQuestions";
import { toast } from "react-toastify";

const QuestionsList = ({ story }) => {
  const [questions, setQuestions] = useState([]);

  const getQuestions = async () => {
    try {
      const response = null;
      if (response) {
        const sort = response.find((item) => item.story._id == story);
        setQuestions(sort.questions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (story) getQuestions();
  }, [story]);

  // Handle sorting
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    const sorted = arrayMove(questions, oldIndex, newIndex);

    console.log("sorted", sorted);

    const data = {
      questions: sorted,
      story: story,
    };

    setQuestions(sorted);

    const response = null;
    if (response) {
      toast.success("Question updated successfully");
    }
    // answerSort(sorted);
  };

  return (
    <>
      <SortQuestions questions={questions} onSortEnd={onSortEnd} />
    </>
  );
};

export default QuestionsList;
